const {Component} = require("react");

class Highlight extends Component {

    getSVG(color) {
        return (
            <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 75.5 87.34">
                <defs><style>{ `.cls-1{isolation:isolate;}.cls-2{opacity:0.05;mix-blend-mode:multiply;}}` }</style></defs>
                <g className="cls-1">
                    <g data-name="Layer 1">
                        <g className="cls-2">
                            <circle cx="37.61" cy="39.61" r="37.6"/>
                            <path d="M68.87,60.49s-12.63,19-33.18,31.27c0,0,10.08-15.63,1.93-25.87"/>
                        </g>
                        <circle className="cls-3" fill={color} cx="37.61" cy="37.61" r="37.6"/>
                        <path className="cls-3" fill={color} d="M68.87,58.49s-12.63,19-33.18,31.27c0,0,10.08-15.63,1.93-25.87"/>
                    </g>
                </g>
            </svg>
        );
    }

    render() {
        const {type, color, content} = this.props;

        if (!content || !color || !type) return null;

        const svg = type === 'bubble' ? this.getSVG(color) : null;

        return (
            <div className={`product-highlight product-highlight__${type}`}>
                {svg}
                <div className="before" style={{borderColor: color}}/>
                <div className="product-highlight__inner" style={{backgroundColor: color}}>
                    <p>{content}</p>
                </div>
                <div className="after" style={{borderColor: color}}/>
            </div>
        )
    }
}

module.exports = Highlight;
